export default {"src":"/_next/static/media/guest-house.ef40b35b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};